(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dibbs-collection"]) return;
  try {
    
  (() => {
    const ensureNewestFirst = () => {
      const url = new URL(window.location.href);
      if (url.pathname.startsWith('/collections/') && !url.searchParams.has('sort_by')) {
        url.searchParams.set('sort_by', 'created-descending');
        window.location.replace(url.toString());
        return false;
      }
      return true;
    };

    if (!ensureNewestFirst()) return;

    const initializeDibbsCollections = () => {
      document.querySelectorAll('[data-db-collection-page]').forEach((root) => {
        const controls = root.querySelector('[data-db-collection-controls]');
        const grid = root.querySelector('[data-db-collection-grid]');
        if (!controls || !grid || controls.dataset.dbBound === 'true') return;
        controls.dataset.dbBound = 'true';

        let cards = Array.from(grid.querySelectorAll('[data-db-filter-card]'));
        const getCardKey = (card) => {
          if (card.dataset.dbProductId) return card.dataset.dbProductId;
          const link = card.querySelector('a[href*="/products/"]');
          if (!link) return '';
          try {
            return new URL(link.getAttribute('href'), window.location.origin).pathname;
          } catch (error) {
            return link.getAttribute('href') || '';
          }
        };
        const loadedCardKeys = new Set();
        cards.forEach((card, index) => {
          card.dataset.dbLoadOrder = card.dataset.dbOrder || String(index);
          const key = getCardKey(card);
          if (key) loadedCardKeys.add(key);
        });
        const categorySelect = controls.querySelector('[data-db-filter-category]');
        const sizeSelect = controls.querySelector('[data-db-filter-size]');
        const colorSelect = controls.querySelector('[data-db-filter-color]');
        const availableInput = controls.querySelector('[data-db-filter-available]');
        const sortSelect = controls.querySelector('[data-db-sort]');
        const clearButton = controls.querySelector('[data-db-filter-clear]');
        const activeCount = controls.querySelector('[data-db-active-count]');
        const emptyMessage = root.querySelector('[data-db-filter-empty]');
        const normalize = (value) => (value || '').trim().toLowerCase();
        const humanize = (value) => value.replace(/[-_]+/g, ' ').replace(/\b[a-z]/g, (letter) => letter.toUpperCase());

        const fillOptions = (select, values) => {
          const placeholder = select.querySelector('option[value=""]');
          select.replaceChildren(placeholder.cloneNode(true));
          Array.from(values).sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' })).forEach((value) => {
            const option = document.createElement('option');
            option.value = value;
            option.textContent = humanize(value);
            select.append(option);
          });
        };

        const splitValues = (value) => (value || '').split('|').map(normalize).filter(Boolean);
        const refreshFilterOptions = () => {
          const previousValues = {
            category: categorySelect.value,
            size: sizeSelect.value,
            color: colorSelect.value,
          };
          const categories = new Set();
          const sizes = new Set();
          const colors = new Set();

          cards.forEach((card) => {
            if (card.dataset.dbCategory) categories.add(normalize(card.dataset.dbCategory));
            splitValues(card.dataset.dbSizes).forEach((value) => sizes.add(value));
            splitValues(card.dataset.dbColors).forEach((value) => colors.add(value));
          });

          fillOptions(categorySelect, categories);
          fillOptions(sizeSelect, sizes);
          fillOptions(colorSelect, colors);
          categorySelect.value = categories.has(previousValues.category) ? previousValues.category : '';
          sizeSelect.value = sizes.has(previousValues.size) ? previousValues.size : '';
          colorSelect.value = colors.has(previousValues.color) ? previousValues.color : '';
        };

        refreshFilterOptions();

        const applyFilters = () => {
          const category = normalize(categorySelect.value);
          const size = normalize(sizeSelect.value);
          const color = normalize(colorSelect.value);
          const inStockOnly = availableInput.checked;
          const selectedFilterCount = [category, size, color].filter(Boolean).length + (inStockOnly ? 1 : 0);
          const visibleCards = [];

          cards.forEach((card) => {
            const matchesCategory = !category || normalize(card.dataset.dbCategory) === category;
            const matchesSize = !size || splitValues(card.dataset.dbSizes).includes(size);
            const matchesColor = !color || splitValues(card.dataset.dbColors).includes(color);
            const matchesAvailability = !inStockOnly || card.dataset.dbAvailable === 'true';
            const isVisible = matchesCategory && matchesSize && matchesColor && matchesAvailability;
            card.hidden = !isVisible;
            if (isVisible) visibleCards.push(card);
          });

          if (sortSelect.value === 'price-descending') {
            visibleCards.sort((a, b) => Number(b.dataset.dbPrice) - Number(a.dataset.dbPrice));
          } else if (sortSelect.value === 'price-ascending') {
            visibleCards.sort((a, b) => Number(a.dataset.dbPrice) - Number(b.dataset.dbPrice));
          } else {
            visibleCards.sort((a, b) => Number(a.dataset.dbLoadOrder) - Number(b.dataset.dbLoadOrder));
          }
          visibleCards.forEach((card) => grid.append(card));

          emptyMessage.hidden = visibleCards.length > 0;
          activeCount.textContent = selectedFilterCount ? `(${selectedFilterCount})` : '';
          activeCount.hidden = selectedFilterCount === 0;
        };

        [categorySelect, sizeSelect, colorSelect, availableInput, sortSelect].forEach((control) => {
          control.addEventListener('change', applyFilters);
        });
        clearButton.addEventListener('click', () => {
          categorySelect.value = '';
          sizeSelect.value = '';
          colorSelect.value = '';
          availableInput.checked = false;
          sortSelect.value = 'featured';
          applyFilters();
        });
        applyFilters();

        const loadStatus = root.querySelector('[data-db-load-status]');
        const serverSort = new URL(window.location.href).searchParams.get('sort_by') || 'created-descending';
        const normalizeNextUrl = (value) => {
          if (!value) return '';
          const url = new URL(value, window.location.origin);
          if (!url.searchParams.has('sort_by')) url.searchParams.set('sort_by', serverSort);
          return url.toString();
        };
        let nextUrl = normalizeNextUrl(grid.dataset.dbNextUrl || '');
        let isLoading = false;
        let observer;
        let sentinel;
        const loadedUrls = new Set();

        const loadNextPage = async () => {
    if (!nextUrl || isLoading) return;

    const requestUrl = new URL(nextUrl, window.location.origin).href;
    if (loadedUrls.has(requestUrl)) {
      observer?.disconnect();
      return;
    }

    loadedUrls.add(requestUrl);
    isLoading = true;
    loadStatus.hidden = false;
    loadStatus.textContent = 'Loading more finds…';

    try {
      const response = await fetch(requestUrl, {
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      });
      if (!response.ok) throw new Error('Collection page failed to load');

      const html = await response.text();
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const nextGrid = parsed.querySelector('[data-db-collection-grid]');
      if (!nextGrid) throw new Error('Collection grid was not found');

      let nextOrder = cards.length;
      const fragment = document.createDocumentFragment();
      nextGrid.querySelectorAll('[data-db-filter-card]').forEach((card) => {
        const key = getCardKey(card);
        if (key && loadedCardKeys.has(key)) return;
        if (key) loadedCardKeys.add(key);
        card.dataset.dbLoadOrder = card.dataset.dbOrder || String(nextOrder);
        nextOrder = Math.max(nextOrder, Number(card.dataset.dbLoadOrder) + 1);
        fragment.append(card);
      });
      grid.append(fragment);

      cards = Array.from(grid.querySelectorAll('[data-db-filter-card]'));
      refreshFilterOptions();
      applyFilters();

      nextUrl = normalizeNextUrl(nextGrid.dataset.dbNextUrl || '');
      if (!nextUrl) {
        observer?.disconnect();
        sentinel?.remove();
      } else {
        observer?.observe(sentinel);
      }
      loadStatus.hidden = true;
    } catch (error) {
      loadedUrls.delete(requestUrl);
      loadStatus.hidden = false;
      loadStatus.textContent = 'More finds could not load. Please refresh and try again.';
    } finally {
      isLoading = false;
    }
  };

        if (nextUrl && 'IntersectionObserver' in window) {
          sentinel = document.createElement('div');
          const scrollRoot = root.closest('.page-wrapper');
          sentinel.className = 'db-collection-load-sentinel';
          sentinel.setAttribute('aria-hidden', 'true');
          grid.insertAdjacentElement('afterend', sentinel);

          observer = new IntersectionObserver(
            (entries) => {
              if (entries.some((entry) => entry.isIntersecting)) {
                observer?.unobserve(sentinel);
                loadNextPage();
              }
            },
            { root: scrollRoot || null, rootMargin: '900px 0px' }
          );
          observer.observe(sentinel);
        }

        const maybeLoadNextPage = () => {
          if (!nextUrl || isLoading) return;
          if (window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 1200) {
            loadNextPage();
          }
        };
        window.addEventListener('scroll', maybeLoadNextPage, { passive: true });
        window.addEventListener('resize', maybeLoadNextPage);
        maybeLoadNextPage();
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeDibbsCollections, { once: true });
    } else {
      initializeDibbsCollections();
    }
    document.addEventListener('shopify:section:load', initializeDibbsCollections);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dibbs-home"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-db-review-wall]').forEach((section) => {
    if (section.dataset.reviewWallReady === 'true') return;
    section.dataset.reviewWallReady = 'true';
    const viewport = section.querySelector('[data-review-viewport]');
    const previous = section.querySelector('[data-review-prev]');
    const next = section.querySelector('[data-review-next]');
    const dialog = section.querySelector('[data-review-dialog]');
    const dialogImage = section.querySelector('[data-review-dialog-image]');
    const dialogLabel = section.querySelector('[data-review-dialog-label]');
    const dialogQuote = section.querySelector('[data-review-dialog-quote]');
    const scrollByCards = (direction) => viewport.scrollBy({ left: direction * Math.max(viewport.clientWidth * 0.78, 300), behavior: 'smooth' });
    previous.addEventListener('click', () => scrollByCards(-1));
    next.addEventListener('click', () => scrollByCards(1));
    section.querySelectorAll('[data-review-card]').forEach((card) => {
      card.addEventListener('click', () => {
        dialogImage.src = card.dataset.reviewImage;
        dialogImage.alt = card.querySelector('img').alt;
        dialogLabel.textContent = card.dataset.reviewLabel;
        dialogQuote.textContent = `“${card.dataset.reviewQuote}”`;
        if (typeof dialog.showModal === 'function') dialog.showModal();
      });
    });
    section.querySelector('[data-review-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
